<template>
    <div>
        <Tweet v-bind:id="id" error-message="ツイートがロードできません。" error-message-class="tweet--not-found"><div class="spinner"></div></Tweet>
    </div>
</template>

<script>
import { Tweet } from 'vue-tweet-embed'

export default {
  props: ['url'],
  components: {
    Tweet
  },
  data: () => ({
    id: ''
  }),
  created: function () {
    this.id = this.getTweetID(this.url)
  },
  methods: {
    getTweetID (url) {
      /* twitter URL のID部分を取得して返す */
      const data = url.split('/')
      const id = data[data.length - 1].split('?')[0]
      return id
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/Twitter.vue